import {COLORS, SCREEN_MD} from 'shared/consts';
import {adaptiveValue, toEm, toRem} from 'shared/helpers';
import styled, {css} from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100dvh;
  padding: ${toRem(20)};
  display: flex;
  justify-content: center;
  align-items: safe center;
  background-color: ${COLORS.BG.SURFACE3};
  overflow: hidden auto;

  @media (width < ${toEm(SCREEN_MD)}) {
    flex-direction: column;
    justify-content: flex-end;
    align-items: stretch;
  }
`;

export const RegisterWindow = styled.form`
  position: relative;
  background-color: ${COLORS.BG.PAGE};
  padding-top: ${toRem(32)};
  padding-bottom: ${toRem(32)};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${adaptiveValue('border-radius', 32, 28, 1440, 360)}
  ${adaptiveValue('padding-left', 32, 16, 1440, 360)}
  ${adaptiveValue('padding-right', 32, 16, 1440, 360)}
  

  @media (width >= ${toEm(SCREEN_MD)}) {
    width: ${toRem(374)};
  }
  @media (width < ${toEm(SCREEN_MD)}) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    min-height: 69dvh;
    overflow: auto;
  }

  .back-button {
    position: absolute;
    top: ${toRem(32)};
    left: ${toRem(20)};
  }

  .consent-checkbox {
    align-items: flex-start;
  }

  .consent-checkbox .checkbox__container {
    flex: 0 0 auto;
    margin-top: ${toRem(1)};
  }

  .consent-checkbox .checkbox__label {
    font-size: ${toRem(14)};
    line-height: ${18 / 14};
    white-space: normal;
  }
`;

type TitleProps = {
  $mb?: number;
};

export const Title = styled.h1<TitleProps>`
  font-weight: 700;
  font-size: ${toRem(20)};
  line-height: ${24 / 20};
  &:not(:last-child) {
    ${(props) => css`
      margin-bottom: ${toRem(props.$mb || 8)};
    `}
  }
`;

export const Subtitle = styled.p`
  font-size: ${toRem(16)};
  line-height: ${20 / 16};
  &:not(:last-child) {
    margin-bottom: ${toRem(32)};
  }
`;

export const ConsentText = styled.span`
  display: inline;
  font-size: ${toRem(14)};
  line-height: ${18 / 14};

  a {
    color: ${COLORS.ACCENT.DEFAULT};
    display: inline;
    line-height: inherit;
    text-decoration: none;
    white-space: normal;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export const ConsentError = styled.div`
  margin-top: ${toRem(6)};
  color: ${COLORS.ERROR.DEFAULT};
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
`;
